<div class="container">
  <div class="row">
    <div class="col">
      <div class="card">
        <div class="card-header text-center">
          <p class="h4  float-left">Lista Categorías</p>
          <a (click)="createCategory()" class="btn btn-success float-right">
            Crear Categoría</a
          >
        </div>
        <div class="card-body">
          <input
            class="form-control"
            #searchTerm
            (keyup)="search(searchTerm.value)"
            placeholder="Buscar categoría..."
          />
          <div *ngIf="categorias && !categoryService.isLoading">
            <table class="table table-hover table-bordered table-responsive-sm table-sm table-md">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nombre</th>
                  <th>Descripción</th>
                  <th>Habilitado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody *ngFor="let category of categorias.data; let i = index">
                <tr>
                  <th scope="row">
                    {{
                      i +
                        1 +
                        (categorias.current_page - 1) * categorias.per_page
                    }}
                  </th>
                  <td>{{ category.nombre }}</td>
                  <td>
                    <p>{{ category.descripcion }}</p>
                  </td>
                  <td class="mt-2">
                    <label
                      class="switch switch_type1"
                      role="switch"
                      *ngIf="category.habilitado == true"
                    >
                      <input
                        type="checkbox"
                        class="switch__toggle"
                        (click)="enableCategory(category.categoria_id)"
                        checked="false"
                      />
                      <span class="switch__label"></span>
                    </label>
                    <label
                      class="switch switch_type1"
                      role="switch"
                      *ngIf="category.habilitado == false"
                    >
                      <input
                        type="checkbox"
                        class="switch__toggle"
                        (click)="enableCategory(category.categoria_id)"
                      />
                      <span class="switch__label"></span>
                    </label>
                  </td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-default btn-lg"
                      (click)="editModal(category.categoria_id)"
                    >
                      <i class="fa fa-pencil-square-o text-info" style="font-size: 25px"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              Mostrando Categorías {{ categorias.from }} a
              {{ categorias.to }} de
              {{ categorias.total }}
            </p>
            <p>
              Página {{ categorias.current_page }} de {{ categorias.last_page }}
            </p>
            <button (click)="prevPage()" [disabled]="!categorias.prev_page_url">
              Anterior
            </button>
            <button (click)="nextPage()" [disabled]="!categorias.next_page_url">
              Siguiente
            </button>
          </div>
          <p *ngIf="categoryService.isLoading">Cargando...</p>
        </div>
      </div>
    </div>
  </div>
</div>
